/*
 * WebMCP — tools de ZonaPhone para agentes que navegan con navegador.
 *
 *   1. consultar_precio_reparacion  — lo único que un agente NO puede sacar del
 *                                     catálogo: las reparaciones no son
 *                                     productos de Shopify.
 *   2. buscar_iphone                — búsqueda en el catálogo real.
 *   3. info_tienda                  — dirección, horarios y contacto.
 *
 * Sin soporte de navigator.modelContext no hace absolutamente nada.
 * Regla de oro: si no hay dato, se dice que no hay dato. Nunca se estima un
 * precio — un agente lo citaría como firme.
 */
(function () {
  'use strict';

  if (!('modelContext' in navigator)) return;

  var ZP = window.ZP_AGENT || {};

  // Cada tarifa llega como [modelo, concepto, precio, precioMax?]
  var PRICES = Array.isArray(ZP.repairPrices) ? ZP.repairPrices : [];

  // Los enlaces tienen que respetar el prefijo de idioma (/pt, /en) o dan 404.
  function url(path) {
    var root = String(ZP.rootUrl || '/').replace(/\/+$/, '');
    return root + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function absolute(path) {
    return location.origin + url(path);
  }

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function text(payload) {
    return { content: [{ type: 'text', text: JSON.stringify(payload, null, 2) }] };
  }

  // Sinónimos y términos en inglés -> el vocabulario real de los conceptos de
  // Odoo, contra el que se hace la coincidencia por subcadena.
  var ALIAS = {
    screen: 'pantalla', display: 'pantalla', lcd: 'pantalla', oled: 'pantalla',
    battery: 'bateria', pila: 'bateria',
    camera: 'camara', lente: 'camara', lens: 'camara',
    back: 'tapa', backglass: 'tapa', cristaltrasero: 'tapa', tapatrasera: 'tapa',
    port: 'conector', charging: 'conector', puerto: 'conector', carga: 'conector',
    lightning: 'conector', usbc: 'conector',
    faceid: 'faceid', speaker: 'altavoz', motherboard: 'placabase',
    logicboard: 'placabase', water: 'humedad', agua: 'humedad'
  };

  function conceptQuery(input) {
    var q = norm(input);
    return ALIAS[q] || q;
  }

  function modelos() {
    var seen = [];
    for (var i = 0; i < PRICES.length; i++) {
      if (seen.indexOf(PRICES[i][0]) === -1) seen.push(PRICES[i][0]);
    }
    return seen;
  }

  function matchModels(input) {
    var q = norm(input);
    if (!q) return [];
    var todos = modelos();
    var exactos = todos.filter(function (m) { return norm(m) === q; });
    if (exactos.length) return exactos;
    return todos.filter(function (m) { return norm(m).indexOf(q) !== -1; });
  }

  function precioTexto(fila) {
    return fila[3] ? fila[2] + '-' + fila[3] + ' EUR' : fila[2] + ' EUR';
  }

  var tools = [
    {
      name: 'consultar_precio_reparacion',
      description:
        'Consulta el precio de una reparación en ZonaPhone, tienda física en Madrid ' +
        '(C. del Conde de Peñalver 34). Cubre iPhone, iPad, MacBook y Apple Watch: ' +
        'pantalla, batería, cámaras, conector de carga, tapa trasera, Face ID, placa ' +
        'base, daños por humedad y más. Devuelve únicamente tarifas publicadas: si un ' +
        'modelo o una reparación no está, lo dice en vez de estimar.',
      inputSchema: {
        type: 'object',
        properties: {
          modelo: {
            type: 'string',
            description: 'Modelo, por ejemplo "iPhone 13 Pro", "iPad Air 5" o "Apple Watch SERIE 7 41MM". Admite variantes como "13 pro".'
          },
          tipo: {
            type: 'string',
            description: 'Opcional. Reparación concreta: pantalla, batería, cámara, tapa, conector, Face ID, placa base, humedad… Si se omite, devuelve todas las del modelo.'
          }
        },
        required: ['modelo']
      },
      execute: function (args) {
        args = args || {};
        var destino = absolute(ZP.repairPage || '/pages/reparaciones-iphone');

        if (!PRICES.length) {
          return text({
            error: 'Las tarifas no están disponibles en esta página.',
            siguiente_paso: 'Consultarlas en ' + destino + ', o pedir presupuesto sin compromiso (diagnóstico gratuito).'
          });
        }

        var encontrados = matchModels(args.modelo);
        if (!encontrados.length) {
          return text({
            error: 'No hay tarifa publicada para "' + args.modelo + '".',
            modelos_con_tarifa: modelos(),
            siguiente_paso: 'ZonaPhone también repara modelos fuera de esta lista, y Samsung y Xiaomi. Presupuesto en ' + destino
          });
        }

        var q = args.tipo ? conceptQuery(args.tipo) : null;

        var resultados = encontrados.map(function (m) {
          var filas = PRICES.filter(function (f) {
            if (f[0] !== m) return false;
            return q ? norm(f[1]).indexOf(q) !== -1 : true;
          });
          var reparaciones = {};
          filas.forEach(function (f) { reparaciones[f[1]] = precioTexto(f); });
          return { modelo: m, reparaciones: reparaciones };
        }).filter(function (r) { return Object.keys(r.reparaciones).length > 0; });

        if (!resultados.length) {
          return text({
            error: 'No hay tarifa publicada de "' + args.tipo + '" para ese modelo.',
            reparaciones_disponibles: PRICES
              .filter(function (f) { return encontrados.indexOf(f[0]) !== -1; })
              .map(function (f) { return f[1]; }),
            siguiente_paso: 'Pedir presupuesto en ' + destino
          });
        }

        return text({
          resultados: resultados,
          nota: 'Precios orientativos con IVA incluido. El precio final se confirma tras el diagnóstico, que es gratuito.',
          garantia: 'Reparaciones con garantía, en tienda física en Madrid.',
          url: destino
        });
      }
    },

    {
      name: 'buscar_iphone',
      description:
        'Busca iPhone reacondicionados en venta en ZonaPhone (envío a toda España, ' +
        '2 años de garantía). Devuelve modelo, precio, disponibilidad y enlace.',
      inputSchema: {
        type: 'object',
        properties: {
          consulta: { type: 'string', description: 'Qué buscar, por ejemplo "iPhone 14 Pro 256GB".' },
          precio_max: { type: 'number', description: 'Opcional. Precio máximo en euros.' }
        },
        required: ['consulta']
      },
      execute: function (args) {
        args = args || {};
        var base = ZP.searchUrl || url('/search/suggest');
        var endpoint =
          base + '.json?q=' + encodeURIComponent(args.consulta) +
          '&resources[type]=product&resources[limit]=10' +
          '&resources[options][unavailable_products]=last';

        return fetch(endpoint, { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            var products = ((data.resources || {}).results || {}).products || [];

            var items = products.map(function (p) {
              return {
                titulo: p.title,
                precio: p.price ? Number(String(p.price).replace(/[^0-9.]/g, '')) : null,
                moneda: ZP.currency || 'EUR',
                disponible: p.available !== false,
                url: location.origin + p.url
              };
            });

            if (typeof args.precio_max === 'number') {
              items = items.filter(function (i) { return i.precio !== null && i.precio <= args.precio_max; });
            }

            return text({
              resultados: items,
              total: items.length,
              nota: items.length
                ? 'Todos los iPhone incluyen 2 años de garantía.'
                : 'Sin resultados para esa búsqueda.'
            });
          })
          .catch(function (err) {
            return text({ error: 'No se pudo consultar el catálogo: ' + err.message });
          });
      }
    },

    {
      name: 'info_tienda',
      description:
        'Devuelve los datos de la tienda física de ZonaPhone en Madrid: dirección, ' +
        'teléfono, horarios de apertura, valoración y enlaces de contacto.',
      inputSchema: { type: 'object', properties: {} },
      execute: function () {
        // Se lee del JSON-LD que ya emite el tema: una sola fuente de verdad.
        var business = null;
        var nodes = document.querySelectorAll('script[type="application/ld+json"]');

        for (var i = 0; i < nodes.length && !business; i++) {
          try {
            var parsed = JSON.parse(nodes[i].textContent);
            var types = [].concat(parsed['@type'] || []);
            if (types.indexOf('LocalBusiness') !== -1 || types.indexOf('Store') !== -1) {
              business = parsed;
            }
          } catch (e) {
            /* JSON-LD de terceros mal formado: se ignora */
          }
        }

        if (!business) {
          return text({ error: 'Datos de la tienda no disponibles en esta página.' });
        }

        return text({
          nombre: business.name,
          direccion: business.address,
          telefono: business.telephone,
          email: business.email,
          horarios: business.openingHoursSpecification,
          valoracion: business.aggregateRating,
          medios_de_pago: business.paymentAccepted,
          servicios: 'Venta de iPhone reacondicionados y reparación de iPhone, iPad, MacBook y Apple Watch.',
          enlaces: {
            reparaciones: absolute(ZP.repairPage || '/pages/reparaciones-iphone'),
            contacto: absolute(ZP.contactPage || '/pages/contact')
          }
        });
      }
    }
  ];

  try {
    if (typeof navigator.modelContext.provideContext === 'function') {
      navigator.modelContext.provideContext({ tools: tools });
    } else if (typeof navigator.modelContext.registerTool === 'function') {
      tools.forEach(function (t) { navigator.modelContext.registerTool(t); });
    }
  } catch (e) {
    /* No romper la página si la API cambia de forma */
  }
})();
